import { z } from 'zod'

import { GamSetupOrderSlice } from 'features/globalSetup/pages/GoogleAdManagerConnectionPage/sections/SetupPrebidStackSection/hooks/useGetGamSetupOrders'
import { zNumericIntegerString } from 'providers/zod/types'

export const schema = z.object({
  nativeTemplateId: zNumericIntegerString.pipe(z.string().min(1)),
})

export type Schema = z.infer<typeof schema>

export const schemaDefault = (gamSetupOrder?: GamSetupOrderSlice): Schema => {
  const { nativeTemplateId } = gamSetupOrder ?? {}

  return {
    nativeTemplateId: nativeTemplateId ?? '',
  }
}
